var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-check custom-checkbox-wrapper"},[_c('input',{class:[
      'form-check-input',
      'custom-checkbox',
      _vm.isDisabled ? 'disabled' : ''
    ],attrs:{"id":_vm.id,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.isChecked},on:{"change":function($event){_vm.isDisabled ? '' : _vm.$emit('input', $event.target.checked)}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[_vm._v(" Accept Terms & conditions checkbox ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }